import { Manufacturer } from '#/graphql/types';
import { Key } from '#/types';

export const updateMutationFields: Key<Manufacturer>[] = [
  'name',
  'inUseStatus',
  'contactPerson',
  'contactEmail',
  'contactPhone',
  'description',
  'countryId',
  'address',
  'website',
  'vendorPortalLink',
  'slaDetails',
  'warrantyPolicies',
];

export const createMutationFields: Key<Manufacturer>[] = [
  'name',
  'tenantId',
  'contactPerson',
  'contactEmail',
  'contactPhone',
  'description',
  'countryId',
  'address',
  'website',
  'vendorPortalLink',
  'slaDetails',
  'warrantyPolicies',
];
